var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TagStatus", {
    attrs: { id: _vm.state, label: _vm.label, size: "small", type: "ocr" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }